import { getModalEntry } from "../config/modal-registry";
import { useAppModalsStore } from "../store/app-modals-store";
import { useAppModalTriggers } from "../triggers/use-app-modal-triggers";

/** Single outlet for app-wide modals. Mount once in the webapp shell. */
export function AppModalsHost() {
  useAppModalTriggers();

  const active = useAppModalsStore((s) => s.active);
  const close = useAppModalsStore((s) => s.close);

  if (!active) return null;

  const { Component } = getModalEntry(active);
  return <Component type={active} onClose={close} />;
}
